<template>
  <dd-modal
      :width="820"
      :show-cancel="true"
    :visible="modalVisible"
    @cancel="$emit('cancel')">
    <dd-header-card :header="header">
      <dd-main-table
          :has-select="false"
          :rounded="true"
          :loading="loading"
          :headers="tableHeaders"
          :rows="rows"/>
    </dd-header-card>
  </dd-modal>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import policyApi from '~/api/policy';
export default {
  name: "BonusMalusTable",
  props: {
    modalVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rows: [],
      loading: true,
      tableHeaders: [
        {
          title: 'Trede',
          key: (row) => row.step,
          width: '100px',
        },
        {
          title: 'Percentage',
          key: (row) => row.percentage + '%',
          width: '100px',
        },
        {
          title: 'Geen schades',
          key: (row) => row.step0damage,
          width: '100px',
        },
        {
          title: '1 schade',
          key: (row) => row.step1damage,
          width: '100px',
        },
        {
          title: '2 schades',
          key: (row) => row.step2damage,
          width: '100px',
        },
        {
          title: '3 schades',
          key: (row) => row.step3damage,
          width: '100px',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(`$_generic_insurance`, {
      premiumMatrices: 'premiumMatrices',
    }),
    ...mapState(`$_generic_insurance`, {
      primary_premium_type: state => state.form.primary_premium_type,
    }),
    header() {
      return 'Bonus/Malus tabel voor ' + this.premiumMatrices[this.primary_premium_type];
    },
  },
  watch: {
    primary_premium_type() {
      this.loading = true;
      policyApi.premiumMatricesByNumber(this.primary_premium_type).then((response) => {
        this.loading = false;
        this.rows = response.data;
      });
    }
  },
  created() {
    policyApi.premiumMatricesByNumber(this.primary_premium_type).then((response) => {
        this.loading = false;
      this.rows = response.data;
    });
  },
};
</script>

<style scoped>

</style>
